import { render, staticRenderFns } from "./transaction-failed-container.vue?vue&type=template&id=46b9e962&scoped=true&lang=pug"
import script from "./transaction-failed-container.js?vue&type=script&lang=js&external"
export * from "./transaction-failed-container.js?vue&type=script&lang=js&external"
import style0 from "./transaction-failed-container.vue?vue&type=style&index=0&id=46b9e962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9e962",
  null
  
)

export default component.exports